import React from 'react'
import { HashRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { Provider } from 'react-redux'
import { theme } from '../theme'
import { Routes } from '../routes'
import { store } from '../store'
import { Selection } from '../components/Selection'

type AppProps = {}

export const App: React.FC<AppProps> = () => (
  <ThemeProvider theme={theme}>
    <>
      <Provider store={store}>
        <HashRouter>
          <Routes />
        </HashRouter>
        <Selection />
      </Provider>
    </>
  </ThemeProvider>
)
